import Api from "@/services/api";
import {
	LOAD_KEYS,
	CREATE_KEY,
	EDIT_KEY,
	REMOVE_KEY,
	REMOVE_KEYS,
	ADD_ALERT,
} from "@/store/_actiontypes";
import {
	SET_KEY,
	ADD_KEY,
	UPDATE_KEY,
	DELETE_KEY,
} from "@/store/_mutationtypes";

const state = {
	keylist: [],
};

const actions = {
	[LOAD_KEYS]({ commit }) {
		Api.get("/keys").then((response) => {
			let vkey = response.data;
			commit(SET_KEY, vkey);
		});
	},
	[CREATE_KEY]({ commit, dispatch }, { key }) {
		return Api.post("/keys", {
			name: key.name,
			value: key.value,
			typeId: key.typeId,
		}).then((response) => {
			let vkey = response.data;
			commit(ADD_KEY, vkey);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Key added successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[EDIT_KEY]({ commit, dispatch }, { key }) {
		return Api.put(`/keys/${key.id}`, key).then((response) => {
			let vkey = response.data;
			commit(UPDATE_KEY, vkey);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Key updaded successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_KEY]({ commit, dispatch }, { id }) {
		Api.delete(`/keys/${id}`).then(() => {
			commit(DELETE_KEY, id);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Key deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_KEYS]({ commit, dispatch }, { ids }) {
		ids.forEach((id) => {
			Api.delete(`/keys/${id}`).then(() => {
				commit(DELETE_KEY, id);
			});
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Selected keys deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
};

const mutations = {
	[SET_KEY](state, keys) {
		state.keylist = keys;
	},
	[ADD_KEY](state, keys) {
		state.keylist.push(keys);
	},
	[UPDATE_KEY](state, key) {
		let vkey = state.keylist.find((h) => h.id == key.id);
		vkey.name = key.name;
		vkey.value = key.value;
		vkey.typeId = key.typeId;
	},
	[DELETE_KEY](state, id) {
		state.keylist = state.keylist.filter((h) => h.id != id);
	},
};

export const keys = {
	namespaced: true,
	state,
	actions,
	mutations,
};
